import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-026066c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "detail-block" }
const _hoisted_3 = { class: "info-head df aic" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-block" }, null, -1))
const _hoisted_5 = {
  class: "info-head-title",
  style: {"flex":"1","line-height":"32px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目经历", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_8 = {
  key: 0,
  class: "detail-item-block"
}
const _hoisted_9 = { class: "df jcsb" }
const _hoisted_10 = { style: {"flex":"1"} }
const _hoisted_11 = { class: "card-line-btn-group" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = {
  key: 0,
  class: "item-line"
}
const _hoisted_15 = {
  key: 1,
  class: "no-explist-info"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 暂无项目经历")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("立即添加")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_v_preview_item = _resolveComponent("v-preview-item")!
  const _component_v_preview = _resolveComponent("v-preview")!
  const _component_ProjectExperience = _resolveComponent("ProjectExperience", true)!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              class: "card-header-btn",
              icon: _ctx.CirclePlus,
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit('新增项目经历')))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ]),
        (_ctx.detail.projectExpList && _ctx.detail.projectExpList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.projectExpList, (item, index) => {
                return (_openBlock(), _createBlock(_component_v_preview, {
                  itemTopSpace: "5px",
                  "label-width": "130px",
                  style: {"margin":"0 auto"},
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_preview_item, {
                      width: "50%",
                      label: "项目名称"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.projectName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_preview_item, {
                      width: "50%",
                      label: "项目角色"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(item.projectRole), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_el_button, {
                              class: "card-line-btn",
                              icon: _ctx.EditPen,
                              type: "text",
                              onClick: ($event: any) => (_ctx.edit('编辑项目经历', item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 2
                            }, 1032, ["icon", "onClick"]),
                            _createVNode(_component_el_button, {
                              class: "card-line-btn",
                              icon: _ctx.Delete,
                              type: "text",
                              onClick: ($event: any) => (_ctx.deleteInfo(item, index))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["icon", "onClick"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_preview_item, {
                      width: "50%",
                      label: "项目周期"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$utils.dateFm(item.startDate, "YYYY-MM-DD")) + " ~ " + _toDisplayString(_ctx.$utils.dateFm(item.endDate, "YYYY-MM-DD")), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_preview_item, {
                      width: "100%",
                      label: "项目描述",
                      content: item.content,
                      type: "textarea"
                    }, null, 8, ["content"]),
                    (index !== _ctx.detail.projectExpList.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_button, {
                type: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit('新增项目经历')))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.diaLogTitle,
      width: "880px",
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ProjectExperience, {
          isDialog: true,
          closeDialog: _ctx.closeDialog,
          successCallBack: _ctx.save,
          detailData: { formArr: _ctx.projectExpList }
        }, null, 8, ["closeDialog", "successCallBack", "detailData"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}